<template>
  <div class="treeNoChoose">
    <div class="selectSpot2" style="height:300px;overflow: auto;width: 500px">
      <el-tree v-if="isRouterAlive"
               :expand-on-click-node="false"
               :data="treeListData"
               :props="defaultProps"
               accordion
               :load="loadNode"
               lazy
               node-key="id"
               show-checkbox
               :default-expanded-keys="defaultKeys"
               :current-node-key="currentKey"
               highlight-current
               ref="tree"
               @check-change="checkChange"
               @node-click="handleNodeClickDevice">
        <div class="custom-tree-node" slot-scope="{node,data}">
          <div class="title" style="display: flex">
            <p>
              <template v-if="dataTree.cardShow">
                <i class="el-icon-s-management" v-if="data.type=='1'"></i>
              </template>
            </p>

            <el-tooltip class="item" effect="dark" :content="data.name" placement="top-start" v-if="data.name.length>8">
              <p
                style="max-width: 100%;overflow: hidden;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
                {{ data.name }}</p>
            </el-tooltip>
            <p
              style="max-width: 100%;overflow: hidden;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;"
              v-if="data.name.length<=8">
              {{ data.name }}</p>
          </div>
        </div>
      </el-tree>
    </div>
    <div class="selectStatus" v-if="dataTree.funtoGetMes=='1'&&dataTree.add!='1'">
      <div @click="addEquipmentType(0)">
        <p style="cursor: pointer">
          <i class="el-icon-circle-plus"></i>{{ $t('label_463') }}</p>
      </div>
    </div>
    <el-dialog
      v-loading="saveLoading"
      :title="editEqumentName"
      :visible.sync="dialogEquDeviceAdd" append-to-body
      :close-on-click-modal='false'
      width="400px"
      top="20%"
      :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogMes">
        <p>{{ $t('label_297') }}</p>
        <div class="mesInput">
          <el-input v-model="newType.name"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="newTypeSave">{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-dialog
      v-loading="saveLoading"
      :title="$t('btn_55')"
      :visible.sync="dialogEquDeviceCopy" append-to-body
      :close-on-click-modal='false'
      width="700px"
      top="15%"
      :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogMes">
        <!-- <div style="width: 350px;height: 200px;overflow: auto">
          <p>复制到</p>
          <el-tree
            :data="treeListDataCopy"
            :props="defaultProps"
            accordion
            :load="loadNodeCopy"
            lazy
            node-key="id"
            :default-expanded-keys="['0']"
            show-checkbox :check-strictly="true" @check="checkFn"
            ref="tree2"
            @node-click="handleNodeClickDeviceCopy">
            <div class="custom-tree-node" slot-scope="{node,data}">
              <p class="title" style="width:200px">
                <template v-if="dataTree.cardShow">
                  <i class="el-icon-s-management"></i>
                </template>
                {{data.name}}
              </p>
            </div>
          </el-tree>
        </div> -->
        <div class="dialogMes" style="margin: 50px 0 0 10px;">
          <p style="text-align: right;padding-right: 20px">{{ $t('label_593') }}</p>
          <div class="mesInput" style="width: 200px">
            <el-input v-model="copyType.name" :disabled="true"></el-input>
          </div>
        </div>
        <div class="dialogMes" style="margin: 50px 0 0 10px;">
          <p style="text-align: right;padding-right: 20px">{{ $t('label_668') }}</p>
          <div class="mesInput" style="width: 100px">
            <el-input
              onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
              type="number" v-model="copyType.num"
              @input="copyType.num = copyType.num.replace(/^(0+)|[^\d]+/g, '')"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="copyTypeSave">{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-drawer
      :title="$t('label_420')"
      :visible.sync="drawer"
      size="calc(100% - 600px)"
      append-to-body
      direction="rtl">

      <div class="dialogBoxMes" style="padding:0 20px;height: calc(100% - 20px)">
        <div class="treeMes">
          <div class="chooseBoxDevice" style="height: 180px">
            <div class="devicePic">
              <div class="pic" style="position:relative;">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typ icode.com/posts/"
                           :show-file-list="false" :disabled="true" :http-request="upload">
                  <i class="el-icon-picture-outline" v-if="!cardData.img"></i>
                  <img style="width: 150px;height: 150px;position:absolute;left: 0;top: 0" v-if="cardData.img"
                       :src="$store.getters.getPostUrl+'mes/sysFile/download/'+cardData.img">
                </el-upload>
              </div>
            </div>
            <div class="selectBox">
              <div class="selectChoose">
                <div class="selectText"><p>{{ $t('label_593') }}</p></div>
                <div class="select">
                  <p>{{ cardData.equipmentName }}</p>
                </div>
              </div>
              <div class="selectChoose">
                <div class="selectText"><p>{{ $t('label_194') }}</p></div>
                <div class="select">
                  <p>{{ cardData.equipmentCode }}</p>
                </div>
              </div>
              <div class="selectChoose">
                <div class="selectText"><p>{{ $t('label_423') }}(h)</p></div>
                <div class="select">
                  <p>{{ cardData.lifeTime }}</p>
                </div>
              </div>
              <div class="selectChoose">
                <div class="selectText">
                  <p>{{ $t('label_672') }}</p>
                </div>
                <div class="select">
                  <p>{{ cardData.maker }}</p>
                </div>
              </div>
            </div>
            <div class="selectBox">
              <div class="selectChoose">
                <div class="selectText"><p>{{ $t('label_429') }}</p></div>
                <div class="select">
                  <p style="width: 300px;">{{ cardData.equipmentTypeName }}</p>
                </div>
              </div>
              <div class="selectChoose">
                <div class="selectText"><p>{{ $t('label_161') }}</p></div>
                <div class="select">
                  <p>{{ cardData.deptName }}</p>
                </div>
              </div>
              <div class="selectChoose">
                <div class="selectText"><p>{{ $t('label_481') }}</p></div>
                <div class="select">
                  <p>{{ cardData.startUseTime == null ? '' : cardData.startUseTime.substring(0, 10) }}</p>
                </div>
              </div>
            </div>
            <div class="selectBox">
              <div class="selectChoose">
                <div class="selectText">
                  <p>{{ $t('label_436') }}:</p>
                </div>
                <div class="select">
                  <p>{{ cardData.repair }}</p>
                </div>
              </div>
              <div class="selectChoose">
                <div class="selectText">
                  <p>{{ $t('label_432') }}:</p>
                </div>
                <div class="select">
                  <p>{{ cardData.saler }}</p>
                </div>
              </div>
              <div class="selectChoose">
                <div class="selectText">
                  <p>{{ $t('label_439') }}:</p>
                </div>
                <div class="select">
                  <p>{{ cardData.buyTime == null ? '' : cardData.buyTime.substring(0, 10) }}</p>
                </div>
              </div>
            </div>
            <div class="buttonBox">
              <div>
                <div class="chooseButton searchButton" style="margin: 10px 0;width:100px;"
                     v-if="cardData.operationState=='1'">{{ $t('btn_23') }}
                </div>
                <div class="chooseButton deleteButton" style="margin: 10px 0;width:100px;"
                     v-if="cardData.operationState=='2'">{{ $t('btn_24') }}
                </div>

                <div class="chooseButton searchButton"
                     style="width:100px;margin-left: 0;cursor: not-allowed;background: #ffb400"
                     v-if="cardData.failureState=='2'">{{ $t('label_408') }}
                </div>

                <div class="chooseButton searchButton" style="margin: 10px 0;width:100px;cursor: not-allowed;"
                     v-if="cardData.lifeState=='1'">{{ $t('label_426') }}
                </div>
                <div class="chooseButton searchButton"
                     style="margin: 10px 0;width:100px;cursor: not-allowed;background: #ffb400"
                     v-if="cardData.lifeState=='2'">{{ $t('label_442') }}
                </div>
                <div class="chooseButton deleteButton" style="margin: 10px 0;width:100px;cursor: not-allowed;"
                     v-if="cardData.lifeState=='3'">{{ $t('label_446') }}
                </div>
              </div>
            </div>
            <!-- <div class="buttonBox">
              <div>
                <div class="chooseButton searchButton" style="margin: 10px 0;width:100px;">运行</div>
                <div class="chooseButton searchButton" style="width:100px;margin-left: 0;background: #ffb400">故障</div>
                <div class="chooseButton deleteButton" style="margin: 10px 0;width:100px;">寿命到达</div>
              </div>
            </div> -->
          </div>
          <div class="spotMes2Box" :style="{'height': 'calc(100% - 250px)'}">
            <div class="spotMesBox" style="height: 100%">
              <el-tabs v-model="activeNameSpot" @tab-click="handleClickSpot">
                <el-tab-pane :label="$t('label_335')" name="spot">
<!--                  <div class="chooseBox chooseDevice" style="padding:0;height:100px;border-bottom: 1px solid #efefef;">
                    <div class="selectBox" style="width: 100%">
                      <div class="selectChoose selectChoose22">
                        <div class="selectText">
                          <p>{{ $t('label_672') }}:</p>
                        </div>
                        <div class="select">
                          <p>{{ cardData.maker }}</p>
                        </div>
                      </div>
                      <div class="selectChoose selectChoose22">
                        <div class="selectText"><p>{{ $t('label_436') }}:</p></div>
                        <div class="select">
                          <p>{{ cardData.repair }}</p>
                        </div>
                      </div>
                      <div class=" selectChoose selectChoose22">
                        <div class="selectText"><p>{{ $t('label_432') }}:</p></div>
                        <div class="select">
                          <p>{{ cardData.saler }}</p>
                        </div>
                      </div>
                      <div class=" selectChoose selectChoose22">
                        <div class="selectText"><p>{{ $t('label_439') }}:</p></div>
                        <div class="select">
                          <p>{{ cardData.buyTime == null ? '' : cardData.buyTime.substring(0, 10) }}</p>
                        </div>
                      </div>
                    </div>
                  </div>-->
                  <div class="chooseBox chooseDevice" style="padding:0;overflow: auto;height: 400px">
                    <div class="selectBox deviceSelectBox" style="width: 100%">
                      <template v-for="(item, i) in parameterData">
                        <div class="selectChoose">
                          <div class="selectText"><p>{{ item.name }}</p></div>
                          <div class="select">
                            <p>{{ item.parameter }} {{ item.unit }}</p>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('label_533')" name="pro">
                  <div class="tabMes" style="height: 600px">
                    <checkItem ref="checkItemDisplay" :showButton="false"></checkItem>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('label_533')" name="bao">
                  <div class="tabMes" style="height: 600px">
                    <maintenanceItem ref="maintenanceItemDisplay" :showButton="false"></maintenanceItem>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('label_143')" name="xun">
                  <div class="tabMes" style="height: 600px">
                    <inspectionItem ref="inspectionItemDisplay" :showButton="false"></inspectionItem>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('label_338')" name="txt">
                  <div class="tabMes" style="height: 600px">
                    <electronDocument ref="electronDocumentDisplay" :showButton="false"></electronDocument>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('label_119')" name="backup">
                  <div class="tabMes" style="height: 600px">
                    <partInfo ref="partInfoDisplay" :showButton="false"></partInfo>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('label_340')" name="position">
                  <div class="tabMes" style="height: 600px">
                    <position ref="positionDisplay" :showButton="false"></position>
                  </div>
                </el-tab-pane>
                <!--<el-tab-pane label="设备履历" name="lvli">
                  <div class="chooseBox">
                    <div class="selectBox">
                      <div>
                        <div class="selectChoose">
                          <div class="selectText"><p>时间</p></div>
                          <div class="select">
                            <el-date-picker
                              v-model="Readytime"
                              type="daterange"
                              :range-separator="$t('label_264')"
                              :start-placeholder="$t('label_329')"
                              :end-placeholder="$t('label_388')">
                            </el-date-picker>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="selectChoose">
                          <div class="selectText"><p>分类</p></div>
                          <div class="select">
                            <el-select value="点检">
                              <el-option value="0">点检</el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="buttonBox">
                      <div>
                        <div class="chooseButton sendButton"><i class="el-icon-search"></i>查询</div>
                      </div>
                    </div>
                  </div>
                  <el-table
                    ref="singleTable"
                    :data="tableDeviceLvli"
                    highlight-current-row
                    border
                    height="440px"
                    style="width: 100%;height:100%;margin: 10px"
                    :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                    <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex"
                                     width="50">
                    </el-table-column>
                    <el-table-column
                      prop="type"
                      label="分类" align="center">
                    </el-table-column>
                    <el-table-column
                      prop="time"
                      label="时间" align="center">
                    </el-table-column>
                    <el-table-column
                      prop="user"
                      label="人员" align="center">
                    </el-table-column>
                    <el-table-column
                      prop="status"
                      label="状态" align="center">
                    </el-table-column>
                  </el-table>
                </el-tab-pane>-->
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import file from "@/assets/js/common/common.js";
import file1 from "@/assets/js/file/file.js";
import checkItem from "@/components/list/displayPage/checkItemParam";
import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
import electronDocument from "@/components/list/displayPage/electronDocumentParam";
import partInfo from "@/components/list/displayPage/partInfoParam";
import position from "@/components/list/displayPage/positionParam";
import utils from '@/utils/utils'

export default {
  name: "tree",
  components: {
    checkItem,
    maintenanceItem,
    inspectionItem,
    electronDocument,
    partInfo,
    position
  },
  props: {
    treeType: {
      type: Number,
      default: 0
    },
    dataTree: {
      type: Object,
      default: {}
    },
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      saveLoading: false,
      restaurants: [],
      name: '',
      timeout: null,
      treeList: [],
      defaultKeys: ['0'],
      currentKey: '',
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      Readytime: '',
      editEqumentName: this.$t('label_466'),
      drawer: false,
      drawerTab: false,
      isRouterAlive: true,
      newType: {
        name: '',
        operationState: '1',
        failureState: '1',
        lifeState: '1',
        pid: '0'
      },
      copyType: {
        id: '',
        num: '',
        pid: '0',
        name: ''
      },
      dialogEquDeviceAdd: false,
      dialogEquDeviceCopy: false,
      activeNameSpot: 'spot',
      searchDataList: {
        equipmentId: '',
        versionFlag: 0,
        deviceId: ''
      },
      tableDeviceLvli: [
        {
          type: '点检',
          time: '2021/01/01 08:00-08:20',
          user: '张三',
          status: '已检'
        }, {
          type: '点检',
          time: '2021/01/01 08:00-08:20',
          user: '张三',
          status: '已检'
        }, {
          type: '点检',
          time: '2021/01/01 08:00-08:20',
          user: '张三',
          status: '已检'
        }, {
          type: '点检',
          time: '2021/01/01 08:00-08:20',
          user: '张三',
          status: '已检'
        }],
      tableDataTree: [],
      tableDataTxt: [],
      cardData: [],
      parameterData: [],
      checkInfoData: [],
      maintainInfoData: [],
      inspectionInfoData: [],
      documentInfoData: [],
      partInfoData: [],
      openData: [],
      checked: false,
      treeListData: [
        {
          name: this.$t('label_272'),
          id: '0',
          children: [{}]
        }
      ],
      treeListDataCopy: [{
        name: this.$t('label_272'),
        id: 0,
        children: [{}]
      }],
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: function (data) {
          if (data.type == '1') {
            return true
          } else {
            return false
          }
        }
      },
    }
  },
  watch: {},
  methods: {
    jump(data) {
      this.$emit('jump', data);
    },
    clearSearch() {
      this.$refs.myAutocomplete.handleFocus()
    },
    querySearchAsync(queryString, cb) {
      let param = {}
      if (queryString == undefined) {
        param = {name: ''}
      } else {
        param = {name: queryString}
      }
      //类型 0：类型 1：区域
      if (this.treeType == 0) {
        file1.selectTypeListByName(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            cb(data.data)
          }
        }).catch((response) => {
          console.log(response)
        })
      } else {
        file1.selectDeptListByName(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            cb(data.data)
          }
        }).catch((response) => {
          console.log(response)
        })
      }

    },
    handleSelect(item) {
      this.expand(item.id, this.treeType);
    },
    expand(id, type) {
      file1.findPids({id: id, type: type}).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.defaultKeys = data.data;
          setTimeout(() => {
            this.$refs.tree.setCurrentKey(id);
            let node0 = this.$refs.tree.getCurrentNode();
            this.open(node0);
          }, 500)
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    expand2(data0, type) {
      let id = type == 0 ? data0.equipmentTypeId : data0.deptId;
      file1.findPids({id: id, type: type}).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.defaultKeys = data.data;
          setTimeout(() => {
            this.$refs.tree.setCurrentKey(data0.id);
          }, 500)
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },

    upload(file1) {
      var formData = new FormData();
      formData.append('file', file1.file);
      file.upload(formData).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.cardData.img = data.data
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    addEquipmentType(id) {
      this.dialogEquDeviceAdd = true;
      if (this.dataTree.funtoGetMes == '1') {
        this.editEqumentName = this.$t('label_466');
      } else {
        this.editEqumentName = this.$t('label_460');
      }
      this.newType.pid = id;
      this.newType.equipmentTypeId = id;
    },
    editClick(name, id, pid) {
      if (this.dataTree.funtoGetMes == '1') {
        this.editEqumentName = this.$t('label_485');
      } else {
        this.editEqumentName = this.$t('label_482');
      }
      this.newType.name = name;
      this.newType.id = id;
      this.newType.pid = pid;
      this.dialogEquDeviceAdd = true;
    },
    delEquipmentType(id) {
      let param = {
        id: id
      };
      let that = this;
      this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
        confirmButtonText: this.$t('label_100'),
        cancelButtonText: this.$t('btn_1'),
        type: 'warning'
      }).then(() => {
        if (this.dataTree.funtoGetMes == '1') {
          file.delEquipmentType(param).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              that.reload();
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        }
        if (this.dataTree.funtoGetMes == '2') {
          file.delEquipmentInfo(param).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              that.reload();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        }
      }).catch(() => {

      });
    },
    copyClick(id, name) {
      this.copyType.pid = id;
      this.copyType.name = name;
      this.dialogEquDeviceCopy = true;
    },
    checkFn(node, data) {
      let checkedKeys = data.checkedKeys;
      let currKey = node.id;
      this.copyType.pid = node.id;
      // this.$refs.tree2.setCheckedKeys([currKey]);
    },
    newTypeSave() {
      this.saveLoading = true;
      if (this.newType.name == "") {
        utils.messageAlert(this.$t('msg_30'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return
      }
      if (this.editEqumentName == this.$t('label_466') || this.editEqumentName == this.$t('label_460')) {
        if (this.dataTree.funtoGetMes == '1') {
          file.addEquipmentType(this.newType).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
              this.reload();
              this.dialogEquDeviceAdd = false;
              this.newType = {
                name: '',
                pid: '0'
              };
            } else {
              this.$message({
                message: this.$t('msg_143'),
                type: 'error'
              });
            }
            this.saveLoading = false;
          }).catch((response) => {
            console.log(response)
            this.saveLoading = false;
          })
        }
        if (this.dataTree.funtoGetMes == '2') {
          file.addEquipmentInfo(this.newType).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
              this.reload();
              this.dialogEquDeviceAdd = false;
              this.newType = {
                name: '',
                pid: '0'
              };
            }
            this.saveLoading = false;
          }).catch((response) => {
            console.log(response)
            this.saveLoading = false;
          })
        }
      } else {
        if (this.dataTree.funtoGetMes == '1') {
          file.editEquipmentType(this.newType).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
              this.reload();
              this.dialogEquDeviceAdd = false;
              this.newType = {
                name: '',
                pid: '0'
              };
            }
            this.saveLoading = false;
          }).catch((response) => {
            console.log(response)
            this.saveLoading = false;
          })
        }
        if (this.dataTree.funtoGetMes == '2') {
          file.editEquipmentInfo(this.newType).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_23'),
                type: 'success'
              });
              this.reload();
              this.dialogEquDeviceAdd = false;
              this.newType = {
                name: '',
                pid: '0'
              };
            }
            this.saveLoading = false;
          }).catch((response) => {
            console.log(response)
            this.saveLoading = false;
          })
        }
      }
    },
    copyTypeSave() {
      this.saveLoading = true;
      if (this.copyType.pid == "") {
        utils.messageAlert(this.$t('input_48'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return
      }
      if (this.copyType.num == "") {
        utils.messageAlert(this.$t('input_47'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return
      }
      if (this.dataTree.funtoGetMes == '1') {
        file.copyEquipmentType(this.copyType).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.reload();
            this.dialogEquDeviceCopy = false;
            // this.$refs.tree2.setCheckedKeys([]);
            this.copyType = {
              id: '',
              name: '',
              pid: ''
            };
            this.$message({
              message: this.$t('msg_23'),
              type: 'success'
            });
          } else {
            utils.messageAlert(this.$t('msg_144'), this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
        })
      }
      if (this.dataTree.funtoGetMes == '2') {
        file.copyEquipment(this.copyType).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.reload();
            this.dialogEquDeviceCopy = false;
            // this.$refs.tree2.setCheckedKeys([]);
            this.copyType = {
              id: '',
              name: '',
              pid: ''
            };
          } else {
            utils.messageAlert(this.$t('msg_148'), this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
        })
      }
    },
    handleClose() {
      // if (this.dialogEquDeviceCopy) {
      //   this.$refs.tree2.setCheckedKeys([]);
      // }
      this.dialogEquDeviceAdd = false;
      this.dialogEquDeviceCopy = false;
      this.newType = {
        name: '',
        pid: '0'
      };
      this.copyType = {
        id: '',
        name: '',
        pid: ''
      };
    },
    handleClickSpot(tab, event) {
      if (tab.label == this.$t('label_335')) {
        this.heightNum = '360';
      } else {
        this.heightNum = '170';
      }
    },
    loadNode(node, resolve) {
      let that = this;
      if (this.dataTree.dataAll) {
        if (node.level === 0) {
          this.$emit('getDeviceMes', node.data[0]);
          return resolve([{
            name: this.$t('label_272'),
            id: '0',
            leaf: false
          }])
        } else {
          if (node.level === 1) {
            let child = [];
            if (this.dataTree.funtoGetMes == '1') {
              child = this.getEquipmentTypeList(0);
            } else if (this.dataTree.funtoGetMes == '2') {
              child = this.getEquipmentInfoList(0)
            } else if (this.dataTree.funtoGetMes == '3') {
              child = this.getEquipmentAreaInfoList(0)
            }
            child.then((res) => {
              resolve(res);
            })
          } else {
            let child = [];
            if (this.dataTree.funtoGetMes == '1') {
              child = this.getEquipmentTypeList(node.data.id);
            }
            if (this.dataTree.funtoGetMes == '2') {
              child = this.getEquipmentInfoList(node.data.id)
            }
            if (this.dataTree.funtoGetMes == '3') {
              child = this.getEquipmentAreaInfoList(node.data.id)
            }
            child.then((res) => {
              if (res == "") {
                return resolve([]);
              } else {
                resolve(res);
              }
            })
          }
        }
      } else {
        if (node.level === 0) {
          let child = [];
          if (this.dataTree.funtoGetMes == '1') {
            child = this.getEquipmentTypeList(0);
          }
          if (this.dataTree.funtoGetMes == '2') {
            child = this.getEquipmentInfoList(node.data.id);
          }
          if (this.dataTree.funtoGetMes == '3') {
            child = this.getEquipmentAreaInfoList(node.data.id)
          }
          child.then((res) => {
            this.$emit('getDeviceMes', res[0]);
            resolve(res);
          })
        } else {
          let child = [];
          if (this.dataTree.funtoGetMes == '1') {
            child = this.getEquipmentTypeList(node.data.id);
          }
          if (this.dataTree.funtoGetMes == '2') {
            child = this.getEquipmentInfoList(node.data.id);
          }
          if (this.dataTree.funtoGetMes == '3') {
            child = this.getEquipmentAreaInfoList(node.data.id)
          }
          child.then((res) => {
            if (res == "") {
              return resolve([]);
            } else {
              resolve(res);
            }
          })
        }
      }
    },
    loadNodeCopy(node, resolve) {
      let that = this;
      if (node.level === 0) {
        return resolve([{
          name: this.$t('label_272'),
          id: '0',
          leaf: false
        }])
      } else {
        if (node.level === 1) {
          let child = [];
          if (this.dataTree.funtoGetMes == '1') {
            child = this.getEquipmentTypeList(0);
          } else if (this.dataTree.funtoGetMes == '2') {
            child = this.getEquipmentInfoList(0)
          } else if (this.dataTree.funtoGetMes == '3') {
            child = this.getEquipmentAreaInfoList(0)
          }
          child.then((res) => {
            resolve(res);
          })
        } else {
          let child = [];
          if (this.dataTree.funtoGetMes == '1') {
            child = this.getEquipmentTypeList(node.data.id);
          }
          if (this.dataTree.funtoGetMes == '2') {
            child = this.getEquipmentInfoList(node.data.id)
          }
          if (this.dataTree.funtoGetMes == '3') {
            child = this.getEquipmentAreaInfoList(node.data.id)
          }
          child.then((res) => {
            if (res == "") {
              return resolve([]);
            } else {
              resolve(res);
            }
          })
        }
      }
    },
    handleNodeClickDevice(data, checked, resolve) {
      this.copyType.id = data.id;
      this.openData = data;
      if (data.type != 1) {
        this.$emit('getDeviceMes', data);
      } else {
        this.$emit('getDeviceMes2', data);
      }
    },
    checkChange(data, check, checked) {
      this.$emit('getTreeList', this.$refs.tree.getCheckedNodes());
    },
    handleNodeClickDeviceCopy(data, checked, resolve) {

    },
    open(data) {
      this.$emit('getDeviceMes', data);
    },
    showCard(id) {
      this.drawer = true;
      this.drawerTab = true;
      this.selectCard(id);
      this.getEquipmentParameter(id);
      let param = {
        pageNum: 1,
        pageSize: 10,
      }
      this.searchDataList.equipmentId = id;
      this.searchDataList.deviceId = id;
      var newParam = Object.assign(param, this.searchDataList);
      this.$nextTick(() => {
        this.$refs.checkItemDisplay.newMes(id, 1);
        this.$refs.maintenanceItemDisplay.newMes(id, 1);
        this.$refs.inspectionItemDisplay.newMes(id, 1);
        this.$refs.electronDocumentDisplay.newMes(id, 1);
        this.$refs.partInfoDisplay.newMes(id, 1);
        this.$refs.positionDisplay.newMes(id);
        this.search();
      })
    },
    async getEquipmentTypeList(param) {
      let childArr = [];
      await file.getEquipmentTypeList(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          childArr = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return childArr
    },
    async getEquipmentInfoList(param) {
      let childArr = [];
      let mes = {};
      if (param) {
        mes = {
          deviceId: param
        }
      } else {
        mes = {
          type: '1',
          deviceId: param
        }
      }
      await file.getEquipmentInfoList(mes).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          childArr = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return childArr
    },
    async getEquipmentAreaInfoList(param) {
      let childArr = [];
      let mes = {};
      if (param) {
        mes = {
          areaId: param
        }
      } else {
        mes = {
          type: '2',
          areaId: param
        }
      }
      await file.getEquipmentInfoList(mes).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          childArr = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return childArr
    },
    selectCard(id) {
      file1.selectCard(id).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.cardData = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    searchPage(param) {
      var dataParam = this.searchDataList;
      var newParam = Object.assign(param, dataParam);
    },
    search() {
      let param = {
        pageNum: 1,
        pageSize: this.pageSize,
      }
      this.$refs.checkItemDisplay.searchPage(param);
      this.$refs.maintenanceItemDisplay.searchPage(param);
      this.$refs.inspectionItemDisplay.searchPage(param);
      this.$refs.electronDocumentDisplay.searchPage(param);
      this.$refs.partInfoDisplay.searchPage(param);
      this.$refs.positionDisplay.searchPage(param);
    },
    getEquipmentParameter(param) {
      file1.getEquipmentParameter(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.parameterData = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    changeTime(value) {
      var arr = value;
      if (arr == null || arr == "") {
        return "-";
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].toString().length == 1) {
            arr[i] = "0" + arr[i];
          }
        }
        if (arr.length == 5) {
          var getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + "00";
        } else {
          var getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + arr[5];
        }
        return getFormatTime;
      }
    }
  },
  created() {
    //this.getEquipmentTypeList(0,1)
  }
}
</script>

<style>
.el-tabs .el-tabs__content {
  /* overflow: scroll; */
  overflow-x: auto;
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/list/tree/inspectionTree.vue